import { useEffect } from "react";
import { useLazyVerifyProviderQuery } from "@/redux/apis/auth/authApi";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { setConfig, setKindeConfig, setSiteInfo } from "@/redux/slices/config/configSlice";
import { configSelector } from "@/redux/slices/config/selectors";
import { SiteConfig } from "@/redux/slices/config/types";
import { transformRMConfig } from "../helpers";

type UseRMConfig =
  | {
      isReady: false;
      config?: undefined;
    }
  | {
      isReady: true;
      config: SiteConfig;
    };

const RMConfig = window.rm ? window.rm.config : undefined;

export const useRMConfig = (): UseRMConfig => {
  const dispatch = useAppDispatch();
  const config = useAppSelector(configSelector);
  const [verifyProvider] = useLazyVerifyProviderQuery();

  useEffect(() => {
    if (RMConfig) {
      // Set siteInfo from RMConfig
      dispatch(
        setSiteInfo({
          key: RMConfig.site.domain_key,
          isMultiTenant: RMConfig.site.metadata.is_multi_tenant,
          apiUrl: RMConfig.site.url.api,
          url: RMConfig.site.url.domain,
          recaptcha_site_key: RMConfig.site.recaptcha_site_key,
        })
      );
      dispatch(setConfig(transformRMConfig(RMConfig)));

      // Fetch provider config from API to get Kinde auth config
      verifyProvider({ providerCode: RMConfig.site.domain_key, apiUrl: RMConfig.site.url.api })
        .unwrap()
        .then((operator) => {
          if (operator.kindeIssuerUrl && operator.kindeClientId) {
            dispatch(setKindeConfig({ domain: operator.kindeIssuerUrl, clientId: operator.kindeClientId }));
          }
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!config) return { isReady: false, config: undefined };
  return { isReady: true, config } satisfies UseRMConfig;
};
